<template>
  <!-- Fila de moderação dos registros enviados pelos voluntários. O texto só vai para
       a landing page depois que o gestor aprova aqui -- é o que separa este bloco dos
       depoimentos de vitrine acima, que o gestor escreve e publica direto. -->
  <div>
    <div class="layout align-center justify-space-between">
      <h4 class="my-4">Registros enviados pelos voluntários</h4>
      <v-btn small flat class="ma-0" @click="togglePendingOnly">
        {{ pendingOnly ? "Ver todos" : "Ver só os pendentes" }}
      </v-btn>
    </div>

    <div v-if="!list.length" class="f-size-12 text-dark mb-4">
      {{ pendingOnly ? "Nenhum registro aguardando avaliação." : "Nenhum registro enviado até agora." }}
    </div>

    <div
      v-for="item in list"
      :key="'user-testimony-' + item.id"
      class="pa-3 mb-3"
      style="border: 1px solid #e8eaf2; border-radius: 6px"
    >
      <div class="layout align-center justify-space-between wrap">
        <div>
          <strong>{{ item.personName }}</strong>
          <span class="f-size-12 text-dark" v-if="item.offerName"> — {{ item.offerName }}</span>
        </div>
        <div class="f-size-12 text-dark">{{ formatDate(item.insertedAt) }}</div>
      </div>

      <div class="layout gap-sm mt-3 wrap" v-if="item.files && item.files.length">
        <a
          v-for="(photo, index) in item.files"
          :key="'photo-' + item.id + '-' + index"
          :href="photo.file ? photo.file.path : null"
          target="_blank"
          rel="noopener"
        >
          <img
            v-if="photo.file"
            :src="photo.file.path"
            style="width: 96px; height: 96px; object-fit: cover; border-radius: 4px"
          />
        </a>
      </div>

      <p class="mt-3 mb-0" style="white-space: pre-wrap">{{ item.testimony }}</p>

      <template v-if="item.reviewedAt == null">
        <v-textarea
          v-model="notes[item.id]"
          label="Observação da avaliação (opcional, não vai para o voluntário)"
          rows="2"
          class="mt-3"
        ></v-textarea>
        <div class="layout gap-xs justify-end">
          <v-btn outline class="orange text-orange ma-0" @click="review(item, false)">Recusar</v-btn>
          <v-btn class="btn-primary ma-0" @click="review(item, true)">Aprovar e publicar</v-btn>
        </div>
      </template>
      <div v-else class="f-size-12 mt-3" :class="item.isApproved ? 'text-dark' : 'text-orange'">
        {{ item.isApproved ? "Aprovado" : "Recusado" }} em {{ formatDate(item.reviewedAt) }}
        <span v-if="item.reviewNote"> — {{ item.reviewNote }}</span>
      </div>
    </div>
  </div>
</template>

<script type="plain/text">
import moment from "moment";
import VolunteeringService from "@/scripts/services/volunteering.service";
import CommonHelper from "@/scripts/helpers/common.helper";

export default {
  props: {
    volunteeringId: Number,
  },
  data() {
    return {
      volunteeringService: new VolunteeringService(),
      list: [],
      pendingOnly: true,
      // Observação por item, indexada pelo id: um v-model só seria compartilhado por
      // todos os cartões da fila.
      notes: {},
    };
  },
  watch: {
    volunteeringId() {
      this.load();
    },
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      if (!this.volunteeringId) return;
      const result = await this.volunteeringService.listUserTestimoniesForModeration(
        this.volunteeringId,
        this.pendingOnly
      );
      this.list = result || [];
    },
    async togglePendingOnly() {
      this.pendingOnly = !this.pendingOnly;
      await this.load();
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY [às] HH:mm") : "";
    },
    async review(item, approve) {
      const result = await this.volunteeringService.reviewUserTestimony(
        item.id,
        approve,
        this.notes[item.id] || null
      );

      // Erro já foi mostrado pelo serviço; mantém a fila como está.
      if (!result) return;

      CommonHelper.swal(
        approve ? "Publicado" : "Recusado",
        approve
          ? "O depoimento foi publicado na página do voluntariado."
          : "O depoimento foi recusado e não será publicado.",
        "success"
      );

      await this.load();
      this.$emit("reviewed");
    },
  },
};
</script>
